<template>
  <b-modal
    id="addressIntervention-delete-modal"
    :title="'Supprimer ' + $t('l.addressIntervention')"
    @ok="handleOk"
    :ok-title="$t('Delete')"
    ok-variant="danger"
    :cancel-title="$t('Cancel')"
    cancel-variant="danger"
    :hide-footer="isLoading"
  >
    <b-overlay :show="isLoading" rounded="sm">
      <div v-if="!!selectedAddressIntervention">
        Cette action va supprimer
        <span>{{$t('l.addressIntervention')}} <strong>{{ selectedAddressIntervention.name }}</strong></span>, ainsi que toutes les interventions et tous les appareils associés.
        <br><br>Nombre d'interventions : {{selectedAddressIntervention.interventionCount}}
        <br>Nombre d'appareils : {{selectedAddressIntervention.deviceCount}}
        <br><br>Cette action est irréversible, êtes-vous certain de vouloir procéder ?
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>

import api from '../../services/api';

export default {

  name: 'AddressInterventionDeleteModal',

  props: {
    selectedAddressIntervention: Object
  },

  data() {
    return {
      isLoading: false,
    }
  },

  emits: ['didDeleteAddressIntervention'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      this.isLoading = true
      api
        .delete(`/addressIntervention/${this.selectedAddressIntervention.id}`)
        .then(response => {
          this.isLoading = false
          this.$emit('didDeleteAddressIntervention')
          this.hideModal()
          this.successToast(this.$i18n.t('AddressIntervention') + ' "' + this.selectedAddressIntervention.name + '" ' + this.$i18n.t('deleted'))
        })
        .catch((error) => {
          this.isLoading = false
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('addressIntervention-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/addressIntervention/AddressInterventionDeleteModal.vue